export const createOverlay = (target: HTMLElement, index: number): void => {
	const overlay = document.createElement("div");

	overlay.style.cssText = `
    position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		z-index: 2;
  `;

	const glare = document.createElement("div");
	glare.style.cssText = `
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		background: linear-gradient(120deg, transparent 0%, transparent 20%, rgba(255, 255, 255, 0.8) 50%, transparent 80%, transparent 100%);
		background-size: 250% 250%;
		animation: glare 0.5s ease-out forwards;
		animation-delay: ${index * 0.3}s;
  `;

	overlay.appendChild(glare);

	// Correct positioning ensured
	if (window.getComputedStyle(target).position === "static") {
		target.style.position = "relative";
	}

	target.appendChild(overlay);

	// Automatically removed from DOM after animation ends
	setTimeout((): void => overlay.remove(), 2000);
};
